var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._g(_vm._b({attrs:{"type":"text"}},'el-input',_vm.binds,false),_vm.btnListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }